import { render } from "./addRoomFacilities.vue?vue&type=template&id=55cdf0e5&scoped=true"
import script from "./addRoomFacilities.vue?vue&type=script&lang=js"
export * from "./addRoomFacilities.vue?vue&type=script&lang=js"

import "./addRoomFacilities.vue?vue&type=style&index=0&id=55cdf0e5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cdf0e5"]])

export default __exports__